import React from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';
import { SettingsContext } from 'hoc/Settings';
import { FacebookConfig } from 'react-player/facebook';

type VideoPlayerProps = ReactPlayerProps;

const VideoPlayer: React.FC<VideoPlayerProps> = (props: VideoPlayerProps) => {
    const {
        domainSettings: {
            facebook: { appId },
        },
    } = React.useContext(SettingsContext);

    const facebook: FacebookConfig = {
        appId: appId.toString(),
        version: 'v9.0',
        playerId: null,
    };

    const { config = {} } = props;

    return <ReactPlayer {...props} config={{ ...config, facebook }} />;
};

export default VideoPlayer;
